import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default, { createContext, useMemo } from 'react';
import { useId } from '@radix-ui/react-id';
import { Classes } from '@blueprintjs/core';
import cx from 'classnames';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

var _excluded = ["children", "className", "contentClassName", "disabled", "helperText", "hideLabel", "inline", "intent", "label", "labelFor", "labelId", "labelInfo", "style"];
var formGroupContext = /*#__PURE__*/createContext(null);
var FormGroup = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      disabled = _ref.disabled,
      helperText = _ref.helperText,
      hideLabel = _ref.hideLabel,
      inline = _ref.inline,
      intent = _ref.intent,
      label = _ref.label,
      labelFor = _ref.labelFor,
      incomingLabelId = _ref.labelId,
      labelInfo = _ref.labelInfo,
      style = _ref.style,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var classes = cx(Classes.FORM_GROUP, Classes.intentClass(intent), (_cx = {}, _defineProperty(_cx, Classes.DISABLED, disabled), _defineProperty(_cx, Classes.INLINE, inline), _cx), className);
  var labelId = useId(incomingLabelId);
  var formGroupContextValue = useMemo(function () {
    return {
      label: label,
      labelFor: labelFor,
      labelId: labelId
    };
  }, [label, labelFor, labelId]);
  var labelContent = /*#__PURE__*/React__default.createElement("label", {
    className: Classes.LABEL,
    id: labelId,
    htmlFor: labelFor ? labelFor : labelId ? "element-".concat(labelId) : undefined,
    style: {
      display: "flex",
      gap: "0.25em" // Using em so gap grows with font-size.

    }
  }, label, " ", /*#__PURE__*/React__default.createElement("span", {
    className: Classes.TEXT_MUTED
  }, labelInfo));
  return /*#__PURE__*/React__default.createElement(formGroupContext.Provider, {
    value: label ? formGroupContextValue : null
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes,
    style: style,
    ref: ref
  }, otherProps), label || labelInfo ? hideLabel ? /*#__PURE__*/React__default.createElement(VisuallyHidden.Root, null, labelContent) : labelContent : null, /*#__PURE__*/React__default.createElement("div", {
    className: cx(Classes.FORM_CONTENT, contentClassName)
  }, children, helperText && /*#__PURE__*/React__default.createElement("div", {
    className: Classes.FORM_HELPER_TEXT
  }, helperText))));
});

export { FormGroup, formGroupContext };
//# sourceMappingURL=form-group.js.map
